import { render, staticRenderFns } from "./DataSertifikasi.vue?vue&type=template&id=e983eb22&"
import script from "./DataSertifikasi.vue?vue&type=script&lang=js&"
export * from "./DataSertifikasi.vue?vue&type=script&lang=js&"
import style0 from "./DataSertifikasi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports